module.exports = __webpack_public_path__ + "static/media/notification.568a0c1c.png";